import BASEURLGESTTOR from '../api/gesttor'
import { lancamentoCadastroPayload, paransListLancamentos, lancamentoUpdatePayload} from '../../interfaces/lancamentos'

export function novoLancamento (payload: lancamentoCadastroPayload) {
    return BASEURLGESTTOR.post('/lancamentos', payload)
}

export function lisatarLancamentos (params: paransListLancamentos) {
    return BASEURLGESTTOR.get (`/lancamentos?pagina=${params.pagina}&tipo=${params.tipo}&vencimentoInicial=${params.vencimentoInicial}&vencimentoFinal=${params.vencimentoFinal}&cliente=${params.cliente}&descricao=${params.descricao}&situacao=${params.situacao}&recorrencia=${params.recorrencia}&inadimplencia=${params.inadimplencia}`)
}

export function atualizarLancamento (id: string, payload: lancamentoUpdatePayload) {
    return BASEURLGESTTOR.patch(`/lancamentos/${id}`, payload)
}

export function apagarLancamento (id: string) {
    return BASEURLGESTTOR.delete(`/lancamentos/${id}`)
}